export default "__VITE_ASSET__BooFDSHk__"